export default __webpack_public_path__ + "static/media/Pngtreecomputer_monitor_pictur.5410e849.png";